export const SenatorialDistricts = {
    "Abia": [
        "Abia Central",
        "Abia North",
        "Abia South"
    ],
    "Abuja": [
        "Federal Capital Territory"
    ],
    "Adamawa": [
        "Adamawa Central",
        "Adamawa North",
        "Adamawa South"
    ],
    "Akwa Ibom":[
        "Akwa Ibom North East",
        "Akwa Ibom North West",
        "Akwa Ibom South"
    ],
    "Anambra": [
        "Anambra Central",
        "Anambra North",
        "Anambra South"
    ],
    "Bauchi": [
        "Bauchi Central",
        "Bauchi North",
        "Bauchi South"
    ],
    "Bayelsa": [
        "Bayelsa Central",
        "Bayelsa East",
        "Bayelsa West"
    ],
    "Benue": [
        'Benue North East',
        "Benue North West",
        "Benue South"
    ],
    "Borno": [
        "Borno Central",
        "Borno North",
        "Borno South",
    ],
    "Cross River": [
        "Cross River Central",
        "Cross River North",
        "Cross River South"
    ],
    "Delta": [
        "Delta Central",
        "Delta North",
        "Delta South"
    ],
    "Ebonyi": [
        "Ebonyi South",
        "Ebonyi Central",
        "Ebonyi North",
    ],
    "Edo": [
        "Edo South",
        "Edo Central",
        "Edo North"
    ],
    "Ekiti": [
        "Ekiti South",
        "Ekiti Central",
        "Ekiti North"
    ],
    "Enugu": [
        "Enugu North",
        "Enugu East",
        "Enugu West"
    ],
    "Gombe": [
        "Gombe Central",
        "Gombe North",
        "Gombe South"
    ],
    "Imo": [
        "Imo East",
        "Imo North",
        "Imo West"
    ],
    "Jigawa": [
        "Jigawa North - West",
        "Jigawa North - East",
        "Jigawa South - West",
    ],
    "Kaduna": [
        "Kaduna Central",
        "Kaduna North",
        "Kaduna South"
    ],
    "Kano": [
        "Kano South",
        "Kano Central",
        "Kano North"
    ],
    "Katsina": [
        "Katsina Central",
        "Katsina North",
        "Katsina South",
    ],
    "Kebbi": [
        "Kebbi Central",
        "Kebbi North",
        "Kebbi South"
    ],
    "Kogi": [
        "Kogi Central",
        "Kogi East",
        "Kogi West"
    ],
    'Kwara': [
        "Kwara Central",
        "Kwara North",
        "Kwara South"
    ],
    "Lagos": [
        "Lagos West",
        "Lagos Central",
        "Lagos East"
    ],
    "Nasarawa": [
        "Nassarawa South",
        "Nassarawa North",
        "Nassarawa West"
    ],
    "Niger": [
        "Niger East",
        "Niger North",
        "Niger South"
    ],
    "Ogun": [
        "Ogun Central",
        "Ogun East",
        "Ogun West"
    ],
    "Ondo": [
        "Ondo Central",
        "Ondo North",
        "Ondo South"
    ],
    "Osun": [
        "Osun Central",
        "Osun East",
        "Osun West"
    ],
    "Oyo": [
        "Oyo Central",
        "Oyo North",
        "Oyo South"
    ],
    "Plateau": [
        "Plateau Central",
        "Plateau North",
        "Plateau South"
    ],
    "Rivers": [
        "Rivers East",
        "Rivers South East",
        "Rivers West"
    ],
    "Sokoto": [
        "Sokoto East",
        "Sokoto North",
        "Sokoto South"
    ],
    "Taraba": [
        "Taraba Central",
        "Taraba North",
        "Taraba South"
    ],
    "Yobe": [
        "Yobe East",
        "Yobe North",
        "Yobe South",
    ],
    "Zamfara": [
        "Zamfara Central",
        "Zamfara North",
        "Zamfara West",
    ]
}